import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgMarathon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="5 -4 14 24" {...props}>
      <path
        d="M11.2 3.564l.11.013 1.752.332a.85.85 0 01.304.121c.13.056.25.146.342.27l1.591 2.136L16.406 4.4a.858.858 0 011.143-.343c.413.212.571.71.353 1.112l-1.741 3.204a.859.859 0 01-1.433.099l-1.353-1.816-.638 3.185 1.546.675a.814.814 0 01.427 1.082l-1.77 3.91a.856.856 0 01-1.115.422.815.815 0 01-.434-1.085l1.432-3.162-2.315-1.01-.647 1.8a.838.838 0 01-.607.529l-3.217.73a.847.847 0 01-1.015-.614.822.822 0 01.632-.989l2.764-.626.78-2.168a.545.545 0 01.021-.137l.33-1.124.568-2.848-1.356.216-.845 2.365a.767.767 0 01-.969.457.736.736 0 01-.47-.943l.995-2.782a.754.754 0 01.595-.487l2.817-.448a.863.863 0 01.425-.027zM12.5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Marathon')(SvgMarathon);
